import download from './download.lib';
import wishlist from './wishlist.lib';
import toast from '../util/toast';
import tracking from './tracking.lib';

const modules = {
  download,
  wishlist,
  toast,
  tracking,
};

// This modules will be used in React applications through CustomEvent in Twigs.
global.Ridi.modules = {
  ...global.Ridi.modules || {},
  ...modules,
};



// WEBPACK FOOTER //
// ./common/global_modules.js